import React, { useState } from "react";
import { LicenseUpgradeService } from "../../utils/Services";
import { UpgradeLicenseRequest, UpgradeLicenseResponse } from "../../models/UpgradeLicenseModel";
import { WhyUpgrade } from "./WhyUpgrade";

const licenseExample = {
    Id: "12345678-1234-1234-1234-123456789101",
    Name: "RavenDB License Owner",
    Keys: ["aBcDeFgHiJkLmNoPqRsTuVwXyZ", "~!@#$%^&*()_+=-0987654321`"],
};

interface UpgradeFormProps {
    license: string;
    setLicense: (value: string) => void;

    onError: (error: string) => void;
    onNotEligible: (response: UpgradeLicenseResponse) => void;
    onConverted: (response: UpgradeLicenseResponse) => void;
    
    licenseUpgradeService: LicenseUpgradeService

    ravendbVersion: string;
}

export function UpgradeForm(props: UpgradeFormProps) {
    const { onError, onConverted, onNotEligible, license, setLicense, licenseUpgradeService, ravendbVersion } = props;
    const [inProgress, setInProgress] = useState<boolean>(false);

    const onConvertLicense = async (e: any) => {
        e.preventDefault();

        const dto: UpgradeLicenseRequest = {
            license,
        };

        try {
            setInProgress(true);
            const checkResponse = await licenseUpgradeService.convertLicense(dto);

            switch (checkResponse.status) {
                case "Invalid": {
                    onError("Invalid license.");
                    break;
                }
                case "NotEligible": {
                    onError(null);
                    onNotEligible(checkResponse);
                    break;
                }
                case "Converted": {
                    onError(null);
                    onConverted(checkResponse);
                    break;
                }
                case "AlreadyConverted": {
                    onError("This license was already converted.");
                    break;
                }
            }
        } catch (e) {
            onError("Unable to check license. Please try again later. ");
        } finally {
            setInProgress(false);
        }
    };

    return (
        <div className="mainContainer vstack w-100">
            <div className="hero-container vstack w-100 justify-content-center align-items-center">
                    <div className="vstack align-items-center justify-content-center">
                        <span className="eyebrow text-center">License upgrade tool</span>
                        <h1 className="header-light mb-2 mb-md-3 mb-xxl-4 text-center">Upgrade your RavenDB license</h1>
                        <p className="main-paragraph mb-3 mb-md-5 text-center">
                            This tool will help you update your existing RavenDB license to the latest supported version, ensuring compatibility with current releases, features, and performance improvements - without changing your deployment or data.
                        </p>
                        <form onSubmit={onConvertLicense} className="w-100">
                            <div className="license-input-container position-relative">
                                <textarea
                                    required
                                    onChange={(e) => setLicense(e.target.value)}
                                    value={license}
                                    placeholder={`e.g. ${JSON.stringify(licenseExample, null, 4)}`}
                                    rows={8} 
                                    className="license-input form-control p-3"
                                />
                                <div className="tooltip-container position-absolute bottom-0 end-0 m-3">
                                    {!license.trim() && !inProgress && (
                                        <div className="tooltip-text">
                                            Provide your license
                                        </div>
                                    )}
                                    <button
                                        type="submit"
                                        className="btn btn-primary rounded-pill text-white d-flex align-items-center gap-1"
                                        disabled={!license.trim() || inProgress}
                                    >
                                        <i className="icon-arrow-top"></i>
                                        <span>Submit</span>
                                    </button>
                                </div>
                            </div>
                        </form>
                </div>
            </div>
            <WhyUpgrade />
        </div>
    );
}
